<template>
  <div
    class="item1-content-raw"
  >
    <!--<h3>海报模板</h3>-->

    <div class="poster-container">
      <div
        class="poster-box"
        v-for="item in rawData"
        :key="item.id"
        @click="onClick(item)"
      >
        <!-- 图片缩略图 -->
        <!--
        * 2 -> 是图标 (还是缩略图?)
        * 1 -> 是封面
        -->
        <img
          :src="'/' + getAttachmentByType(1, item.attmentDTOList)"
          alt=""
        >
        <!-- 图片名 -->
        <!--<p>{{ item.title }}</p>-->
        <p v-html="item.title"></p>
      </div>
    </div>
    <!-- 底部文字 -->
    <p class="fxtip" v-if="bottomInfo[0]">
      {{ bottomInfo[0] }}
    </p>
  </div>
</template>
<script>
export default {
  name: '',
  props: {
    // 数据源头
    rawData: Array,
    // 底部信息
    bottomInfo: Array,
    // 跳转函数
    onClick: Function
  },
  data () {
    return {}
  },
  created () {
    console.log('PlaybillTemplate-raw:', this.rawData)
  },
  methods: {
    // handleGoTo (item) {
    //   // 素材类型 2 -> 链接
    //   if (item.materialType === 2) {
    //     item.url && (window.location.href = item.url)
    //     // 素材类型 1 -> 图片
    //   } else if (item.materialType === 1) {
    //     // 素材附件 5 -> 长图
    //     let imgUrl = this.getAttachmentByType(5, item.attmentDTOList)
    //     imgUrl && (window.location.href = imgUrl)
    //   }
    //   // window.location.href = 'http://www.Baidu.com'
    // },
    // 获取指定附件类型的 path
    getAttachmentByType (t, attachmentList) {
      for (let e of attachmentList) {
        if (e.attachmentType === t) {
          return e.path
        }
      }
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
* {
  box-sizing: border-box;
}

.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: auto;
  background-color: #efeff1;

  .banner {
    width: 100vw;
    height: 4.853rem;
    //background-color: skyblue;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .container {
    width: 8.84rem;
    //height: 400px;
    padding: 0.467rem 0.2rem;
    margin: 0.48rem 0 0.307rem 0;
    background-color: #FFFFFF;
    border-radius: 0.4rem;
    /* 按钮区 */
    .clBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .cl-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 3.787rem;
        height: 0.96rem;
        margin: 0 0 0.507rem 0;
        font-size: 0.373rem;
        color: #FFFFFF;
        background-color: #2f8cec;
        box-shadow: 0 1px 5px rgba(0, 75, 153, 0.3);
        border-radius: 0.96rem;

        i {
          font-size: 0.64rem; // 24px
          margin: 0 0.267rem 0 0;
        }

        p {
          display: inline-block;
          line-height: 1;
        }
      }
    }

    /* 分隔线 dashed */
    .dashed {
      width: 100%;
      height: 0.027rem;
      border: 0;
    }

    /* 内容区 */
    .item-content {
      width: 100%;
      padding: 0.533rem 0 0 0;
      /* todo 背景颜色 */
      background-color: pink;
      /* 基础材料 */
      .item1-content-raw {
        .item1 {
          display: flex;
          align-items: center;
          width: 100%;
          padding: 0.133rem 0.267rem;
          margin: 0 0 0.293rem 0;
          font-size: 0.373rem;
          color: #FFFFFF;
          background-color: #2f8cec;
          border-radius: 0.267rem;

          i {
            font-size: 0.533rem;
            margin: 0 0.133rem 0 0;
          }
        }
      }

      /* 渠道材料 */
      .password-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 6.667rem;
        //background-color: #fff;
        //background: purple;
        .input-password {
          width: 4.4rem;
          height: 1.2rem;
          font-size: 0.533rem;
          color: #7f7f7f;
          text-align: center;
          border: 2px #13346a solid;
          border-radius: 0.2rem;
        }

        .div-confirm {
          width: 4.4rem;
          height: 1.2rem;
          margin: 0.333rem 0 0 0;
          font-size: 0.533rem;
          color: #ffffff;
          text-align: center;
          line-height: 1.173rem;
          background: #13346a;
          border-radius: 0.2rem;
        }
      }

      /* 宣传海报 */
      .poster-container {
        display: flex;
        flex-wrap: wrap;

        .poster-box {
          width: 33.33%;
          display: flex;
          flex-direction: column;

          img {
            width: 2.1rem;
            height: 2rem;
          }

          p {
            width: 2.1rem;
            padding: 0.333rem 0 0.333rem 0;
            text-align: center;
            word-break: keep-all;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            //text-overflow: ellipsis;
            -webkit-box-orient: vertical;
          }
        }

        .poster-box:nth-of-type(3n - 1) {
          align-items: center;
        }

        .poster-box:nth-of-type(3n) {
          align-items: flex-end;
        }
      }

      /* 媒体报道 */
      .media-container {
        .media-item {
          display: flex;
          align-items: center;
          width: 100%;
          //height: 0.8rem;
          padding: 0.133rem 0.267rem;
          margin: 0 0 0.293rem 0;
          font-size: 0.373rem;
          color: #FFFFFF;
          background-color: #2f8cec;
          border-radius: 0.267rem;

          i {
            font-size: 0.533rem;
            margin: 0 0.133rem 0 0;
          }
        }
      }
    }
  }
}

/* 底部文字 */
.fxtip {
  width: 100%;
  padding: 0.4rem 0 0;
  text-align: justify;
  //font-size: 0.187rem;
  //font-size: 0.3rem;
  //font-size: 0.1rem;
  font-size: calc(0.14 * 100vw / 7.5);
  //line-height: 0.4rem;
  line-height: 0.4rem;
  //line-height: calc(0.20 * 100vw / 7.5);
  color: #070707;
}

/* tab 高亮 */
.cl-item-active {
  background-color: #005ebf !important;
  transition: 0.3s;
}

/* 测试 icon 的编写 */
.icon {
}
</style>



// WEBPACK FOOTER //
// src/components/ui/PlaybillTemplate.vue